import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

const ApiService = {
  init() {
    Vue.use(VueAxios, axios)
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`)
    })
  },

  get(resource) {
    return Vue.axios.get(`${resource}`).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`)
    })
  },

  getWithQuery(resource, query = {}) {
    const queryArr = [];
    Object.keys(query).forEach(key => {
      queryArr.push(`${key}=${query[key]}`);
    });
    const queryString = queryArr.join('&');
    return Vue.axios.get(`${resource}?${queryString}`).catch((error) => {
      throw new Error(`[RWV] ApiService ${error}`)
    })
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params)
  },

  postWithImage(resource, formData) {
    return Vue.axios.post(`${resource}`, formData, {headers:{'Content-Type': 'multipart/form-data'}})
  }
}

export default ApiService
